import React from 'react'
import { connect } from "react-redux"
import AreaCategoriesMenu from './AreaCategoriesMenu'
import ResourcesMenu from './ResourcesMenu'
import SearchIcon from '../../images/icons/SearchIcon'
import { practice_types } from '../../reducers'
import { fetchPracticeTypes } from '../../actions'


class AreasPageContent extends React.Component {
  constructor(props) {
    super(props);
    this.handleProfessionChange = this.handleProfessionChange.bind(this);
    this.state = {
      professionSelection: this.props.professionSelection
    };
  }

  componentDidUpdate(nextProps) {
		const { professionSelection } = this.props;

		if (professionSelection != nextProps.professionSelection) {
			this.state = {
        professionSelection: this.props.professionSelection
      };
		}
	}

  handleProfessionChange(e) {
    this.setState({ professionSelection: e.target.value });
  }


  render() {
    const {
      videos,
      therapy_areas,
      therapy_categories,
      isOnlyParent,
      category,
      search,
      handleSearch,
      compact,
      toggleCompact,
      goToArea,
      practice_types,
      userType
    } = this.props;

    const { professionSelection } = this.state;

    return (
      <main
        className={
          "main areasPageContent " +
          (practice_types.length > 1 ? "showFilter" : "hideFilter")
        }
      >
        {practice_types.length > 1 ? (
          <div className="select">
            Profession:
            <select
              value={professionSelection}
              onChange={e => this.handleProfessionChange(e)}
            >
              {practice_types.map(type => (
                <option key={type.id} value={type.id}>
                  {type.practice_type}
                </option>
              ))}
            </select>
          </div>
        ) : (
          ""
        )}
        {/*<ResourcesMenu active='areas' show_videos={!isOnlyParent()} />*/}
        <ResourcesMenu active="areas" videos={videos} show_videos="true" />
        <AreaCategoriesMenu
          professionSelection={professionSelection}
          categories={therapy_categories}
          active={category}
        />
        <div className="page areaResourcesContent mb8">
          <div className="search-box__input">
            <SearchIcon />
            <input
              type="search"
              onChange={handleSearch}
              className="md-input"
              placeholder="Search"
              value={search}
            />
          </div>

          <br />
          {compact ? (
            <a className="link right" onClick={toggleCompact}>
              Make verbose
            </a>
          ) : (
            <a className="link right" onClick={toggleCompact}>
              Make compact
            </a>
          )}
          <br />
          {therapy_categories
            .filter(cat => cat._id.match(new RegExp(category)))
            .filter(cat => {
              return cat.practice_type == professionSelection;
            })
            .map(cat => (
              <div key={`cat-${cat._id}`}>
                <h5>
                  {cat.image && (
                    <img
                      alt={cat.name}
                      title={cat.name}
                      style={{ verticalAlign: "middle" }}
                      className="category-icon"
                      src={require("../../images/icons/categories/" +
                        cat.image)}
                    />
                  )}
                  {cat.name}
                </h5>

                {therapy_areas
                  .filter(area => area.categories.indexOf(cat._id) !== -1)
                  .map(area => (
                    <div className="-card" key={`area-${area._id}`}>
                      <div className="-card-header">
                        <h7>
                          <a
                            className="link"
                            onClick={() => goToArea(area._id)}
                          >
                            {area.name}
                          </a>
                        </h7>
                      </div>
                      {!compact && (
                        <div>
                          {area.description ? (
                            <div className="-card-content">
                              {area.description.split("\n").map((t, i) => (
                                <p key={`${area._id}-${i}`}>{t}</p>
                              ))}
                            </div>
                          ) : null}
                        </div>
                      )}
                      <hr />
                    </div>
                  ))}
                <br />
              </div>
            ))}
          <br />
        </div>
      </main>
    );
  }
}

AreasPageContent.defaultProps = {
  category: ''
}


// OLD DUMB COMPONENT

// const AreasPageContent = (props) => {
// 	const {
// 		videos,
// 		therapy_areas,
// 		therapy_categories,
// 		isOnlyParent,
// 		category,
// 		search,
// 		handleSearch,
// 		compact,
// 		toggleCompact,
// 		goToArea,
// 		practice_types
// 	} = props;

// 	console.log(props)
	
// 	this.state = {
//     professionSelection: "5e673f588be36a0015b15299"
//   };
	
// 	function handleProfessionChange(e){
// 		this.setState({ professionSelection: e.target.value });
// 	}

// 	return (
//     <main className="main areasPageContent">
//       <div className="select">
//         Profession:
//         <select
//         //   value={this.state.chosenPractice}
//         //   onChange={e => this.handleProfessionChange(e)}
//         >
//           {practice_types.map(type => (
//             <option key={type.id} value={type.id}>
//               {type.practice_type}
//             </option>
//           ))}
//         </select>
//       </div>
//       {/*<ResourcesMenu active='areas' show_videos={!isOnlyParent()} />*/}
//       <ResourcesMenu active="areas" videos={videos} show_videos="true"  />
//       <AreaCategoriesMenu categories={therapy_categories} active={category} />
//       <div className="page areaResourcesContent mb8">
//         <div className="search-box__input">
//           <SearchIcon />
//           <input
//             type="search"
//             onChange={handleSearch}
//             className="md-input"
//             placeholder="Search"
//             value={search}
//           />
//         </div>

//         <br />
//         {compact ? (
//           <a className="link right" onClick={toggleCompact}>
//             Make verbose
//           </a>
//         ) : (
//           <a className="link right" onClick={toggleCompact}>
//             Make compact
//           </a>
//         )}
//         <br />
//         {therapy_categories
//           .filter(cat => cat._id.match(new RegExp(category)))
//           .filter(cat => {
//             console.log(cat)
//             return cat
//           })
//           .map(cat => (
//             <div key={`cat-${cat._id}`}>
//               <h5>
//                 {cat.image && (
//                   <img
//                     alt={cat.name}
//                     title={cat.name}
//                     style={{ verticalAlign: "middle" }}
//                     className="category-icon"
//                     src={require("../../images/icons/categories/" + cat.image)}
//                   />
//                 )}
//                 {cat.name}
//               </h5>

//               {therapy_areas
//                 .filter(area => area.categories.indexOf(cat._id) !== -1)
//                 .map(area => (
//                   <div className="-card" key={`area-${area._id}`}>
//                     <div className="-card-header">
//                       <h7>
//                         <a className="link" onClick={() => goToArea(area._id)}>
//                           {area.name}
//                         </a>
//                       </h7>
//                     </div>
//                     {!compact && (
//                       <div>
//                         {area.description ? (
//                           <div className="-card-content">
//                             {area.description.split("\n").map((t, i) => (
//                               <p key={`${area._id}-${i}`}>{t}</p>
//                             ))}
//                           </div>
//                         ) : null}
//                       </div>
//                     )}
//                     <hr />
//                   </div>
//                 ))}
//               <br />
//             </div>
//           ))}
//         <br />
//       </div>
//     </main>
//   );
// }

// AreasPageContent.defaultProps = {
// 	category: ''
// }

export default AreasPageContent;



// WEBPACK FOOTER //
// ./src/components/home/AreasPageContent.jsx